import script from "./CustomerInputSummaryBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerInputSummaryBlock.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerInputSummaryBlock.vue?vue&type=style&index=0&id=53da2b31&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53da2b31"]])

export default __exports__